export default "__VITE_ASSET__ByEIjxu1__"